import { useState, useEffect } from "react";

function OfflineIndicator() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOffline(false);
      setShowBanner(true);
      // Hide the "back online" message after 3 seconds
      setTimeout(() => setShowBanner(false), 3000);
    };

    const handleOffline = () => {
      setIsOffline(true);
      setShowBanner(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!showBanner && !isOffline) return null;

  return (
    <div
      data-testid="offline-indicator"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        padding: '12px 20px',
        background: isOffline 
          ? 'linear-gradient(90deg, #ff6b6b, #ee5a5a)' 
          : 'linear-gradient(90deg, #51cf66, #40c057)',
        color: '#fff',
        textAlign: 'center',
        zIndex: 9999,
        fontWeight: 'bold',
        fontSize: '0.9rem',
        boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        animation: 'slideDown 0.3s ease-out'
      }}
    >
      <span style={{ fontSize: '1.2rem' }}>
        {isOffline ? '📡' : '✅'}
      </span>
      <span>
        {isOffline 
          ? "You're offline - Some features may be limited" 
          : "You're back online!"}
      </span>
      {!isOffline && (
        <button
          onClick={() => setShowBanner(false)}
          style={{
            background: 'rgba(255,255,255,0.2)',
            border: 'none',
            color: '#fff',
            padding: '4px 12px',
            borderRadius: '4px',
            cursor: 'pointer',
            marginLeft: '10px'
          }}
        >
          Dismiss
        </button>
      )}
      <style>
        {`
          @keyframes slideDown {
            from {
              transform: translateY(-100%);
              opacity: 0;
            }
            to {
              transform: translateY(0);
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  );
}

export default OfflineIndicator;
